/**
 * Sync UTM / click-id tracking params onto cart-level attributes.
 * Reads from pwURLAttributes (cookies) with URL query fallback.
 * When posting, also includes logged-in customer attributes so a tracking
 * /cart/update.js call cannot omit (or race-overwrite) customer info.
 * Does not touch line-item properties.
 */

//@ts-nocheck
(function () {
  const TRACKING_KEYS = [
    'utm_campaign',
    'utm_content',
    'utm_id',
    'utm_medium',
    'utm_source',
    'utm_term',
    'gclid',
    'fbclid',
    'igshid',
  ];

  /**
   * @returns {Record<string, string>}
   */
  function getTrackingParams() {
    const fromPw =
      window.pwURLAttributes && typeof window.pwURLAttributes.getAll === 'function'
        ? window.pwURLAttributes.getAll() || {}
        : {};

    let urlParams = null;
    try {
      urlParams = new URLSearchParams(window.location.search || '');
    } catch {
      urlParams = null;
    }

    /** @type {Record<string, string>} */
    const out = {};
    for (const key of TRACKING_KEYS) {
      let value = fromPw[key];
      if ((value == null || value === '') && urlParams) {
        value = urlParams.get(key);
      }
      if (value != null && value !== '') {
        out[key] = String(value);
      }
    }
    return out;
  }

  /**
   * @param {unknown} phone
   * @returns {string}
   */
  function normalizePhone(phone) {
    if (!phone) return '';
    try {
      let digits = String(phone).replace(/\D/g, '');
      if (digits.length > 10) digits = digits.slice(-10);
      return digits;
    } catch {
      return '';
    }
  }

  /**
   * @returns {Record<string, string>}
   */
  function readUserData() {
    try {
      if (window.user_data && typeof window.user_data === 'object') {
        return window.user_data;
      }
      const raw = window.sessionStorage ? sessionStorage.getItem('user_data') : null;
      return raw ? JSON.parse(raw) : {};
    } catch {
      return {};
    }
  }

  /**
   * Only returns keys that have real values so a guest/tracking sync
   * cannot blank out customer attributes already on the cart.
   * @returns {Record<string, string>}
   */
  function getCustomerCartAttributes() {
    const c = window.__CUSTOMER_DATA__ || {};
    const u = readUserData();
    /** @type {Record<string, string>} */
    const attrs = {};

    const customerId = c.customerId;
    const pwUserId = c.pw_user_id || u.pwUserId;
    const cohortId = c.cohort_id || u.cohortId;
    const phone = normalizePhone(c.phone_number || u.phone);

    if (customerId) attrs.customer_id = String(customerId);
    if (pwUserId) attrs.pw_user_id = String(pwUserId);
    if (cohortId) attrs.cohort_id = String(cohortId);
    if (phone) attrs.customer_phone = phone;

    return attrs;
  }

  /**
   * @param {Record<string, string> | undefined} currentAttributes
   * @param {Record<string, string>} nextAttributes
   * @returns {boolean}
   */
  function needsUpdate(currentAttributes, nextAttributes) {
    const keys = Object.keys(nextAttributes);
    if (!keys.length) return false;
    const current = currentAttributes || {};
    return keys.some((key) => String(current[key] || '') !== String(nextAttributes[key]));
  }

  function syncCartTrackingAttributes() {
    const trackingAttributes = getTrackingParams();
    const customerAttributes = getCustomerCartAttributes();

    // Guest + no UTM: do nothing (web unchanged).
    // App WebView often has no UTM — still sync customer identity when present.
    if (!Object.keys(trackingAttributes).length && !Object.keys(customerAttributes).length) {
      return;
    }

    const syncAttributes = Object.assign({}, customerAttributes, trackingAttributes);

    fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then((response) => response.json())
      .then((cart) => {
        const current = (cart && cart.attributes) || {};
        const nextAttributes = Object.assign({}, current, syncAttributes);

        if (window.cart && window.cart.attributes) {
          Object.assign(window.cart.attributes, nextAttributes);
        }

        if (!needsUpdate(current, syncAttributes)) {
          return null;
        }

        console.log('[cart/update.js] request', nextAttributes);

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          credentials: 'same-origin',
          body: JSON.stringify({ attributes: nextAttributes }),
        }).then((response) => response.json())
          .then((cartJson) => {
            console.log('[cart/update.js] response', cartJson);
            return cartJson;
          });
      })
      .catch(() => {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCartTrackingAttributes);
  } else {
    syncCartTrackingAttributes();
  }
})();
/**
 * Sync UTM / click-id tracking params onto cart-level attributes.
 * Reads from pwURLAttributes (cookies) with URL query fallback.
 * When posting, also includes logged-in customer attributes so a tracking
 * /cart/update.js call cannot omit (or race-overwrite) customer info.
 * Does not touch line-item properties.
 */
(function () {
  const TRACKING_KEYS = [
    'utm_campaign',
    'utm_content',
    'utm_id',
    'utm_medium',
    'utm_source',
    'utm_term',
    'gclid',
    'fbclid',
    'igshid',
  ];

  /**
   * @returns {Record<string, string>}
   */
  function getTrackingParams() {
    const fromPw =
      window.pwURLAttributes && typeof window.pwURLAttributes.getAll === 'function'
        ? window.pwURLAttributes.getAll() || {}
        : {};

    let urlParams = null;
    try {
      urlParams = new URLSearchParams(window.location.search || '');
    } catch {
      urlParams = null;
    }

    /** @type {Record<string, string>} */
    const out = {};
    for (const key of TRACKING_KEYS) {
      let value = fromPw[key];
      if ((value == null || value === '') && urlParams) {
        value = urlParams.get(key);
      }
      if (value != null && value !== '') {
        out[key] = String(value);
      }
    }
    return out;
  }

  /**
   * @param {unknown} phone
   * @returns {string}
   */
  function normalizePhone(phone) {
    if (!phone) return '';
    try {
      let digits = String(phone).replace(/\D/g, '');
      if (digits.length > 10) digits = digits.slice(-10);
      return digits;
    } catch {
      return '';
    }
  }

  /**
   * @returns {Record<string, string>}
   */
  function readUserData() {
    try {
      if (window.user_data && typeof window.user_data === 'object') {
        return window.user_data;
      }
      const raw = window.sessionStorage ? sessionStorage.getItem('user_data') : null;
      return raw ? JSON.parse(raw) : {};
    } catch {
      return {};
    }
  }

  /**
   * Only returns keys that have real values so a guest/tracking sync
   * cannot blank out customer attributes already on the cart.
   * @returns {Record<string, string>}
   */
  function getCustomerCartAttributes() {
    const c = window.__CUSTOMER_DATA__ || {};
    const u = readUserData();
    /** @type {Record<string, string>} */
    const attrs = {};

    const customerId = c.customerId;
    const pwUserId = c.pw_user_id || u.pwUserId;
    const cohortId = c.cohort_id || u.cohortId;
    const phone = normalizePhone(c.phone_number || u.phone);

    if (customerId) attrs.customer_id = String(customerId);
    if (pwUserId) attrs.pw_user_id = String(pwUserId);
    if (cohortId) attrs.cohort_id = String(cohortId);
    if (phone) attrs.customer_phone = phone;

    return attrs;
  }

  /**
   * @param {Record<string, string> | undefined} currentAttributes
   * @param {Record<string, string>} nextAttributes
   * @returns {boolean}
   */
  function needsUpdate(currentAttributes, nextAttributes) {
    const keys = Object.keys(nextAttributes);
    if (!keys.length) return false;
    const current = currentAttributes || {};
    return keys.some((key) => String(current[key] || '') !== String(nextAttributes[key]));
  }

  function syncCartTrackingAttributes() {
    const trackingAttributes = getTrackingParams();
    const customerAttributes = getCustomerCartAttributes();

    // Guest + no UTM: do nothing (web unchanged).
    // App WebView often has no UTM — still sync customer identity when present.
    if (!Object.keys(trackingAttributes).length && !Object.keys(customerAttributes).length) {
      return;
    }

    const syncAttributes = Object.assign({}, customerAttributes, trackingAttributes);

    fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then((response) => response.json())
      .then((cart) => {
        const current = (cart && cart.attributes) || {};
        const nextAttributes = Object.assign({}, current, syncAttributes);

        if (window.cart && window.cart.attributes) {
          Object.assign(window.cart.attributes, nextAttributes);
        }

        if (!needsUpdate(current, syncAttributes)) {
          return null;
        }

        console.log('[cart/update.js] request', nextAttributes);

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          credentials: 'same-origin',
          body: JSON.stringify({ attributes: nextAttributes }),
        }).then((response) => response.json())
          .then((cartJson) => {
            console.log('[cart/update.js] response', cartJson);
            return cartJson;
          });
      })
      .catch(() => {});
  }

  function run() {
    if (document.readyState === 'complete') {
      syncCartTrackingAttributes();
    } else {
      window.addEventListener('load', syncCartTrackingAttributes, { once: true });
    }
  }

  // Fire after load, and on the first page after a Multipass login wait for
  // window.pwPostMultipass (theme.liquid) so this cart write is not the first
  // storefront request to reach a datacenter that has not replicated the session.
  if (window.pwPostMultipass && typeof window.pwPostMultipass.delay === 'function') {
    window.pwPostMultipass.delay(run);
  } else {
    run();
  }
})();
